// @ts-check
import { basicTypes } from 'sinks'
import isFhirDate from 'is-fhir-date'
import { isValidWaveformSVG } from './utils/waveform-svg-validation'

export default {
  ...basicTypes,
  fhirDate: isFhirDate,
  drugRoute: basicTypes.matches([
    'PO',
    'SL',
    'IM',
    'IV',
    'IMAD',
    'IN',
    'local',
    'infusion',
    'infusionBolus',
    'inhalation',
    'fluid',
    'fluidBolus',
    'syringeFlush',
  ]),
  sedationDepth: basicTypes.matches(['moderate', 'deep', 'ga']),
  parenDrugRoute: basicTypes.matches(['IV', 'IMAD', 'IM', 'IN']),
  oralSedativeRoute: basicTypes.matches(['PO', 'SL']),
  infusionRoute: basicTypes.matches(['infusion', 'infusionBolus']),
  localDoseUnit: basicTypes.matches(['ml', 'mg', 'cartridges']),
  drugUnit: basicTypes.matches(['mg', 'mcg']),
  airwayType: basicTypes.matches([
    'nc',
    'nt',
    'nh',
    'cpap',
    'mad',
    'et',
    'ntt',
    'lma',
    'opa',
    'fm',
    'other',
  ]),
  waveSvg: isValidWaveformSVG,
}
